<template>
  <div class="box-request">
    <Navbar />
    <div class="request">
      <vue-good-table class="table-crm" :columns="columns" :rows="rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'tool'">
            <b-button
              v-if="props.row.fullname == null"
              size="sm"
              style="margin-right:5px; background-color:#005a7c"
            >
              <font-awesome-icon icon="check-square" @click="changeStatus(props.row)" />&nbsp;
            </b-button>
          </span>
        </template>
      </vue-good-table>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
export default {
  components: { Navbar, Footer, VueGoodTable },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: "โครงการ",
          field: "project_name",
          sortable: false
        },
        {
          label: "บริษัท/ห้างหุ้นส่วน",
          field: "company_name",
          sortable: false,
          width: "20%"
        },
        {
          label: "รายละเอียด",
          field: "request_remark",
          sortable: false,
          width: "20%"
        },
        {
          label: "เครื่องมือ",
          field: "tool",
          sortable: false,
          tdClass: "text-center",
          width: "8%"
        }
      ]
    };
  },
  mounted() {
    axios.get("https://www.kmppartners.info:1009/api/ebidding/request").then(res => {
      if (res.data.status) {
        if (res.data.response === "ไม่มีรายการเเจ้งข้อมูลผิด") {
          this.$bvModal.msgBoxOk(res.data.response, {
            title: "สำเร็จ",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง"
          });
        } else {
          this.rows = res.data.response;
        }
      } else {
        this.$bvToast.toast("ไม่สามารถเรียกข้อมูลได้", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
      }
    });
  },
  methods: {
    changeStatus: function(data) {
      this.$bvModal
        .msgBoxConfirm("ยืนยันว่าเเก้ไขข้อมูลถูกต้องเเล้ว", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก"
        })
        .then(value => {
          if (value) {
            axios
              .post("https://www.kmppartners.info:1009/api/update/request", {
                id: data.request_id,
                by: this.$session.get('username')
              })
              .then(res => {
                if (res.data.status) {
                  axios
                    .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                      access_username: this.$session.get("username"),
                      access_module: "เเก้ไขสถานะข้อมูลที่เเจ้งผิด",
                      access_ipaddress: this.$session.get("ipaddress")
                    })
                    .then(rest => {
                      if (rest.data.statusLog) {
                        this.$bvModal
                          .msgBoxOk("ดำเนินการเรียบร้อย", {
                            title: "สำเร็จ",
                            size: "sm",
                            buttonSize: "sm",
                            okVariant: "success",
                            headerClass: "p-2 border-bottom-0",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                            okTitle: "ตกลง"
                          })
                          .then(value => {
                            if (value) {
                              location.reload();
                            }
                          });
                      }
                    });
                } else {
                  this.$bvToast.toast(res.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 3000,
                    appendToast: true,
                    variant: "danger"
                  });
                }
              });
          }
        });
    }
  }
};
</script>

<style>
.box-request {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.request {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 10%;
}
.box-request .request .container {
  margin-left: 0px !important;
  margin-right: 0px !important;
  max-width: 100% !important;
}
</style>